import { createAction } from 'redux-actions';

export type PutEntitiesPayload = {
  entities: object;
};
export const putEntities = createAction(`@@entities/PUT`, (payload: PutEntitiesPayload) => payload);
